'use client';

import useReduxListItems from '@alltrails/lists/hooks/useReduxListItems';
import { useTrailCompleted } from '@alltrails/trails';
import type TrailId from '@alltrails/core/types/TrailId';
import CompletionBadge from './CompletionBadge';

type CompletionStatusProps = {
  trailId: TrailId;
};

const CompletionStatus = ({ trailId }: CompletionStatusProps) => {
  const { isVerified } = useReduxListItems();
  const { completed } = useTrailCompleted(trailId);
  const verified = isVerified('trail', trailId);

  if (!completed && !verified) {
    return <></>;
  }

  if (verified) {
    return <CompletionBadge variant="verified" />;
  }

  return <CompletionBadge variant="completed" />;
};

export default CompletionStatus;
